import { useEffect } from 'react';
import { useDialog, useFetchUserDrafts } from '../../hooks';
import { REFETCH_INTERVAL } from '../../utils';

export const useContentDraft = () => {
  const {
    data: draftData,
    isLoading: isFetchingDraftData,
    refetch: refetchDraftData,
  } = useFetchUserDrafts();

  const {
    isDialogOpen: isCreateDraftModelOpen,
    openDialog: handleOpenCreateDraftDialog,
    closeDialog: handleCloseCreateDraftDialog,
  } = useDialog();

  useEffect(() => {
    const isInProgress = draftData?.some(
      (item) => !item?.speechContentId || !item?.speechContent?.content
    );

    let intervalID: NodeJS.Timeout | undefined;

    if (isInProgress) {
      intervalID = setTimeout(() => {
        refetchDraftData();
      }, REFETCH_INTERVAL.DRAFT_VIDEO);
    }

    return () => {
      if (intervalID) {
        clearTimeout(intervalID);
      }
    };
  }, [draftData]);

  return {
    draftData,
    isFetchingDraftData,
    isCreateDraftModelOpen,
    handleOpenCreateDraftDialog,
    handleCloseCreateDraftDialog,
    refetchDraftData,
  };
};
